import header from "./close-up-architecture-with-pen.jpg";
import section1 from "./cheerful-architect-smiling.jpg";
import section2 from "./midsection-architects-working-table-office.jpg";
import section3 from "./floorplan-with-measurements.png";
import section4 from "./laptop-mit-grundriss.jpg";
import section5 from "./precision-laser-level-set-up.jpg";
import section6 from "./real-estate-agent-showing-house-plans.jpg";
import section7 from "./service-maintenance-worker-repairing.jpg";
import section8 from "./tape-measure-laser-distance-meter.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
};
